module.exports = __webpack_public_path__ + "img/Chatting-bro.c759de54.png";